import "./Tournament.scss";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { useAuthStore } from "../store/auth";
import FloatingButtons from "../components/FloatingButtons/FloatingButtons";

type TournamentProps = {
  gameUrl: string;
};

export default function Tournament({gameUrl}: TournamentProps) {
  const token = useAuthStore((state) => state.token);
  const hostname: string = (new URL(gameUrl)).hostname;
  const tournamentUrl = `https://${hostname}/leaderboard/?providerId=zitro&providerOperatorId=showroom&serviceName=showroom`;
  return (
    <div className="tournament">
      <Header searchIsVisible={false} />
      <div className="tournament-iframe-container">
        <iframe title="Tournament Iframe" src={tournamentUrl} className="iframe"></iframe>
      </div>
      <FloatingButtons token={token} />
      <Footer />
    </div>
  );
}
